/**
 * Módulo Centro de Licencias BNT — platform_designer (Fase 3).
 */
import { Navigate, Route } from "react-router-dom";
import PlatformShell from "@/pages/platform/PlatformShell";
import PlatformHome from "@/pages/platform/PlatformHome";
import PlatformOrganizations from "@/pages/platform/PlatformOrganizations";
import PlatformLicenses from "@/pages/platform/PlatformLicenses";
import PlatformLicenseRequests from "@/pages/platform/PlatformLicenseRequests";
import PlatformCommercialTools from "@/pages/platform/PlatformCommercialTools";
import PlatformSafeCleanup from "@/pages/platform/PlatformSafeCleanup";
import PlatformUsers from "@/pages/platform/PlatformUsers";
import PlatformModules from "@/pages/platform/PlatformModules";
import PlatformOnboarding from "@/pages/platform/PlatformOnboarding";

export function getPlatformRouteElements() {
  return (
    <Route path="platform" element={<PlatformShell />}>
      <Route index element={<Navigate to="/platform/license-requests" replace />} />
      <Route path="dashboard" element={<PlatformHome />} />
      <Route path="onboarding" element={<PlatformOnboarding />} />
      <Route path="organizations" element={<PlatformOrganizations />} />
      <Route path="license-requests" element={<PlatformLicenseRequests />} />
      <Route path="commercial-tools" element={<PlatformCommercialTools />} />
      <Route path="safe-cleanup" element={<PlatformSafeCleanup />} />
      <Route path="licenses" element={<PlatformLicenses />} />
      <Route path="users" element={<PlatformUsers />} />
      <Route path="modules" element={<PlatformModules />} />
      {/* Legacy Fase 2 — alias sin componentes huérfanos (ver PlatformOrganizations / PlatformHome) */}
      <Route path="clientes" element={<Navigate to="/platform/organizations" replace />} />
      <Route path="instalaciones" element={<Navigate to="/platform/dashboard" replace />} />
    </Route>
  );
}
